import axios from "axios";
import { toast } from "react-toastify";
import { loginConfirmedAction, logout } from "../store/actions/AuthActions";


export function signUp(email, password) {
  const firebaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY;
  //axios call
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${firebaseApiKey}`,
    postData
  );
}

export function login(email, password) {
  const firebaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY;
  
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${firebaseApiKey}`,
    postData
  );
}

export function formatError(errorResponse) {
  switch (errorResponse.error.message) {
    case "EMAIL_EXISTS":
      //return 'Email already exists';
      toast.error("Email already exists");
      break;
    case "EMAIL_NOT_FOUND":
      //return 'Email not found';
      toast.error("Email not found");
      break;
    case "INVALID_PASSWORD":
      //return 'Invalid Password';
      toast.error("Invalid Password");
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expiresIn * 1000
  );

  // console.log(tokenDetails.expireDate);
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}
let logoutTimer; // Store the timer ID for clearable timeout

export function runLogoutTimer(dispatch, timer, history) {
  // console.log(`Logout timer set for ${timer}ms.`);

  // Clear any existing timer to prevent duplicate ones
  if (logoutTimer) clearTimeout(logoutTimer);

  // Set the new timer
  logoutTimer = setTimeout(() => {
    toast.warn("Your authentication session has expired. HTTP 401 Error.");
    dispatch(logout(history));
    localStorage.removeItem("userDetails"); // Clear stored token
  }, timer);
}

export function checkAutoLogin(dispatch, history) {
  const tokenDetailsString = localStorage.getItem("userDetails");
  // console.log(tokenDetailsString);

  if (!tokenDetailsString) {
    dispatch(logout(history));
    return;
  }

  const tokenDetails = JSON.parse(tokenDetailsString);
  const expiringDate = new Date(tokenDetails.expireDate);
  const currentDate = new Date();

  // console.log(`Token Details:`, tokenDetails);

  // Check if the token has already expired
  if (currentDate >= expiringDate) {
    dispatch(logout(history));
    return;
  }

  dispatch(loginConfirmedAction(tokenDetails));

  // Calculate the remaining time before logout
  const remainingTime = expiringDate.getTime() - currentDate.getTime();
  // console.log(`Remaining time in ms: ${remainingTime}`);

  // Run the logout timer with the remaining time
  runLogoutTimer(dispatch, remainingTime, history);
}
